import { translationFields, updateFields } from 'conf/userGroupFields';
import { createSelector } from 'reselect';
import { formatTime } from 'helpers/formatters';
import { getLocale } from 'actions/language/selectors';
import { getNestedObj } from 'helpers/getNestedObject';

export const getSearch = (state) => state.groups.search;
export const getTotalPages = (state) => state.groups.totalPages;
export const getLimit = (state) => state.groups.limit;
export const getTotal = (state) => state.groups.total;
export const getCurrentPage = (state) => state.groups.currentPage;
export const getLastPaginationPage = createSelector(
  getCurrentPage,
  (currentPage) => currentPage + 4
);
export const getFirstPaginationPage = createSelector(
  getCurrentPage,
  (currentPage) => currentPage - 4
);
export const getUserGroups = (state) => state.groups.userGroups;
export const getFormattedUserGroups = createSelector(
  [getUserGroups, getLimit, getCurrentPage, getLocale],
  (userGroups, limit, currentPage, lang) =>
    userGroups.map((group, index) => ({
      ...group,
      created_at: formatTime(group.created_at, lang),
      updated_at: formatTime(group.updated_at, lang),
      displayIndex: index + limit * currentPage + 1
    }))
);
export const getIsModalOpen = (state) => state.groups.isModalOpen;
export const getIsFetchingProducts = (state) => state.groups.isFetchingProducts;
export const getIsEditModalOpen = (state, props) =>
  state.groups.isEditModalOpen[props.index];
export const getIsEditingGroup = (state, props) =>
  state.groups.isEditing[props.index];

export const getGroupPhones = (state, props) =>
  state.groups.userGroups[props.index].phones;
export const getPhoneOptions = (state) => state.groups.phoneOptions;
export const getLimitDropdownOpen = (state) => state.groups.limitDropdownOpen;
export const getUserGroup = (state, props) =>
  state.groups.userGroups[props.index];
export const getCountriesByCode = (state) => {
  let countryList = [{ defaultOption: true, value: '' }];

  state.groups.countries.forEach((country) => {
    countryList.push({
      name: country.iso_3166_1_alpha_3,
      value: country.country_code
    });
  });

  return countryList;
};

export const getCountriesByName = (state) => {
  let countryList = [{ defaultOption: true, value: '' }];

  state.groups.countries.forEach((country) => {
    countryList.push({
      name: country.name,
      value: country.country_code
    });
  });

  return countryList;
};
export const getLanguageOptions = (state) => state.groups.languageOptions;
export const getGroupLanguageCode = (state, props) => {
  return state.groups.groupLanguage[props.index];
};

export const getUpdateGroupRequest = createSelector(
  [getUserGroup, (state, props) => props.update],
  (userGroup, updatedGroupData) => {
    if (!updatedGroupData || Object.keys(updatedGroupData).length === 0) {
      return null;
    }
    let request = {};

    updateFields.forEach((field) => {
      let value = getNestedObj(updatedGroupData, field.keyPath);
      typeof value !== 'undefined'
        ? (request[field.key] = value)
        : (request[field.key] = getNestedObj(userGroup, field.keyPath));
    });

    return request;
  }
);
export const getTranslationRequest = createSelector(
  [getUserGroup, getGroupLanguageCode, (state, props) => props.update],
  (userGroup, groupLangCode, updatedGroupData) => {
    let request = {};
    let newTranslationDataExists = false;

    translationFields.forEach((field) => {
      if (updatedGroupData && updatedGroupData.hasOwnProperty(field)) {
        newTranslationDataExists = true;
        request[field] = updatedGroupData[field];
      } else {
        request[field] = userGroup[field];
      }
    });
    return newTranslationDataExists
      ? {
          locale: groupLangCode,
          ...request
        }
      : null;
  }
);
export const getPhoneRequest = (state, props) => {
  if ('phones' in props.update) {
    return { phone_line_ids: props.update.phones.map((item) => item.value) };
  }
  return null;
};
export const getMyGroupId = (state) => state.login.groupId;



// WEBPACK FOOTER //
// ./src/actions/accounts/groups/groupsSelectors.js